import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-custom-progress-widget',
  templateUrl: './custom-progress-widget.component.html',
  styleUrls: ['./custom-progress-widget.component.scss'],
  standalone: false
})
export class CustomProgressWidgetComponent {

  @Input() headerIcon!: string;
  @Input() headerText!: string;
  @Input() text1!: string;
  @Input() text2!: string;
  @Input() progressValue!: number;
  @Input() progressTotal!: number;
  @Input() progressColor: 'primary' | 'success' = 'primary';

  constructor() {}

  ngOnInit() {}
}
